import React, { useEffect, useState } from 'react';
import { withRouter, useParams } from 'react-router-dom';
import { Container, Segment, Header } from 'semantic-ui-react';

import { sendRequest, triggerEvent } from '../../helpers/global';
import MarketMapForm from './shared/MarketMapForm';

function MarketMapFormView(props) {
  const { id } = useParams();
  const [initialValues, setInitialValues] = useState({
    name: '',
    goal_ids: [],
  });

  const handleOnSubmit = (values) => {
    sendRequest({
      node: true,
      method: `market-maps${id ? `/${id}` : ''}`,
      type: id ? 'PUT' : 'POST',
      data: values,
      success: (data) => {
        triggerEvent('showSnackbar', [
          { text: 'Market Map saved', type: 'success' },
        ]);
        props.history.push('/market-maps');
      },
      error: (err) => {
        triggerEvent('showSnackbar', [{ text: err.message, type: 'error' }]);
      },
    });
  };

  const loadData = () => {
    sendRequest({
      node: true,
      method: `market-maps/${id}`,
      type: 'GET',
      success: (data) => {
        const { name, goal_ids } = data;
        setInitialValues({ name, goal_ids });
      },
      error: (err) => {
        triggerEvent('showSnackbar', [{ text: err.message, type: 'error' }]);
      },
    });
  };

  useEffect(() => {
    if (id) {
      loadData();
    }
  }, []);

  return (
    <Container>
      <Header as="h2">{`${id ? 'Edit' : 'New'} Market Map`}</Header>
      <Segment>
        <MarketMapForm
          formValues={initialValues}
          onSubmitHandler={handleOnSubmit}
        />
      </Segment>
    </Container>
  );
}

export default withRouter(MarketMapFormView);
